import React from 'react';
import { Box } from '@mui/material';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  useDataProvider,
} from '@ui-framework/index';
import { useFormContext } from 'react-hook-form';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { createdBy, createdDateTime, auditData } from './accesorFuntions';
import tableSchema from './schema/list.json';

export default function JobAuditTable() {
  const { getValues } = useFormContext();
  const serviceJobId = getValues('id');

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';

  const dataProvider = useDataProvider(provider);

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${serviceJobId}/events/audit`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'JobAuditTable',
    dataProvider,
    schema: tableSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      createdDateTime,
      createdBy,
      auditData,
    },
    sortOrder: 'DESC',
    sortBy: 'createdDateTime',
  };

  return (
    <Box sx={{ p: 1 }}>
      <Grid2 sx={{ p: 1 }}>
        <CRUDComponent
          type={CRUD_COMPONENT_TYPE.ADVANCED_LIST}
          listProps={listProps}
        />
      </Grid2>
    </Box>
  );
}
